export default __webpack_public_path__ + "static/media/carousel1.e24e34a0.jpg";